// src/assets/icons/index.js
import { defineAsyncComponent } from 'vue';

const iconModules = import.meta.glob('./*.svg', { eager: false, as: 'url' });

const components = {} as Record<string, ReturnType<typeof defineAsyncComponent>>;

for (const path in iconModules) {
    const fileName = path.split('/').pop();

    if (fileName === undefined) {
        continue;
    }

    const [name, variant] = (fileName.replace(/\.svg$/, '') ?? '').split('_');

    // We ignore variant polartwilight
    if (variant === 'polartwilight') {
        continue;
    }

    const componentName = variant == 'night' ? `WeatherIcon${name}_night` : `WeatherIcon${name}`;

    // We check if the component already exists to avoid overwriting variants
    if (components[componentName]) {
        continue;
    }

    // We need to import as URL to use with img tag and load the svg
    components[componentName] = defineAsyncComponent(() =>
        iconModules[path]().then((url) => ({ template: `<img src="${url}" alt="${componentName}" />` })),
    );
}

export default components;

const clearsky = new URL('@/assets/img/weather/clearsky_day.svg', import.meta.url).href;
const clearsky_night = new URL('@/assets/img/weather/clearsky_night.svg', import.meta.url).href;
const cloudy = new URL('@/assets/img/weather/cloudy.svg', import.meta.url).href;
const fair = new URL('@/assets/img/weather/fair_day.svg', import.meta.url).href;
const fair_night = new URL('@/assets/img/weather/fair_night.svg', import.meta.url).href;
const fog = new URL('@/assets/img/weather/fog.svg', import.meta.url).href;
const heavyrain = new URL('@/assets/img/weather/heavyrain.svg', import.meta.url).href;
const heavyrainandthunder = new URL('@/assets/img/weather/heavyrainandthunder.svg', import.meta.url).href;
const heavyrainshowersandthunder = new URL('@/assets/img/weather/heavyrainshowersandthunder_day.svg', import.meta.url).href;
const heavyrainshowersandthunder_night = new URL('@/assets/img/weather/heavyrainshowersandthunder_night.svg', import.meta.url).href;
const heavyrainshowers = new URL('@/assets/img/weather/heavyrainshowers_day.svg', import.meta.url).href;
const heavyrainshowers_night = new URL('@/assets/img/weather/heavyrainshowers_night.svg', import.meta.url).href;
const heavysleet = new URL('@/assets/img/weather/heavysleet.svg', import.meta.url).href;
const heavysleetandthunder = new URL('@/assets/img/weather/heavysleetandthunder.svg', import.meta.url).href;
const heavysleetshowersandthunder = new URL('@/assets/img/weather/heavysleetshowersandthunder_day.svg', import.meta.url).href;
const heavysleetshowersandthunder_night = new URL('@/assets/img/weather/heavysleetshowersandthunder_night.svg', import.meta.url).href;
const heavysleetshowers = new URL('@/assets/img/weather/heavysleetshowers_day.svg', import.meta.url).href;
const heavysleetshowers_night = new URL('@/assets/img/weather/heavysleetshowers_night.svg', import.meta.url).href;
const heavysnow = new URL('@/assets/img/weather/heavysnow.svg', import.meta.url).href;
const heavysnowandthunder = new URL('@/assets/img/weather/heavysnowandthunder.svg', import.meta.url).href;
const heavysnowshowersandthunder = new URL('@/assets/img/weather/heavysnowshowersandthunder_day.svg', import.meta.url).href;
const heavysnowshowersandthunder_night = new URL('@/assets/img/weather/heavysnowshowersandthunder_night.svg', import.meta.url).href;
const heavysnowshowers = new URL('@/assets/img/weather/heavysnowshowers_day.svg', import.meta.url).href;
const heavysnowshowers_night = new URL('@/assets/img/weather/heavysnowshowers_night.svg', import.meta.url).href;
const lightrain = new URL('@/assets/img/weather/lightrain.svg', import.meta.url).href;
const lightrainandthunder = new URL('@/assets/img/weather/lightrainandthunder.svg', import.meta.url).href;
const lightrainshowersandthunder = new URL('@/assets/img/weather/lightrainshowersandthunder_day.svg', import.meta.url).href;
const lightrainshowersandthunder_night = new URL('@/assets/img/weather/lightrainshowersandthunder_night.svg', import.meta.url).href;
const lightrainshowers = new URL('@/assets/img/weather/lightrainshowers_day.svg', import.meta.url).href;
const lightrainshowers_night = new URL('@/assets/img/weather/lightrainshowers_night.svg', import.meta.url).href;
const lightsleet = new URL('@/assets/img/weather/lightsleet.svg', import.meta.url).href;
const lightsleetandthunder = new URL('@/assets/img/weather/lightsleetandthunder.svg', import.meta.url).href;
const lightsleetshowers = new URL('@/assets/img/weather/lightsleetshowers_day.svg', import.meta.url).href;
const lightsleetshowers_night = new URL('@/assets/img/weather/lightsleetshowers_night.svg', import.meta.url).href;
const lightsnow = new URL('@/assets/img/weather/lightsnow.svg', import.meta.url).href;
const lightsnowandthunder = new URL('@/assets/img/weather/lightsnowandthunder.svg', import.meta.url).href;
const lightsnowshowers = new URL('@/assets/img/weather/lightsnowshowers_day.svg', import.meta.url).href;
const lightsnowshowers_night = new URL('@/assets/img/weather/lightsnowshowers_night.svg', import.meta.url).href;
const lightssleetshowersandthunder = new URL('@/assets/img/weather/lightssleetshowersandthunder_day.svg', import.meta.url).href;
const lightssleetshowersandthunder_night = new URL('@/assets/img/weather/lightssleetshowersandthunder_night.svg', import.meta.url).href;
const lightssnowshowersandthunder = new URL('@/assets/img/weather/lightssnowshowersandthunder_day.svg', import.meta.url).href;
const lightssnowshowersandthunder_night = new URL('@/assets/img/weather/lightssnowshowersandthunder_night.svg', import.meta.url).href;
const partlycloudy = new URL('@/assets/img/weather/partlycloudy_day.svg', import.meta.url).href;
const partlycloudy_night = new URL('@/assets/img/weather/partlycloudy_night.svg', import.meta.url).href;
const partlycloudy_polartwilight = new URL('@/assets/img/weather/partlycloudy_polartwilight.svg', import.meta.url).href;
const rain = new URL('@/assets/img/weather/rain.svg', import.meta.url).href;
const rainandthunder = new URL('@/assets/img/weather/rainandthunder.svg', import.meta.url).href;
const rainshowersandthunder = new URL('@/assets/img/weather/rainshowersandthunder_day.svg', import.meta.url).href;
const rainshowersandthunder_night = new URL('@/assets/img/weather/rainshowersandthunder_night.svg', import.meta.url).href;
const rainshowers = new URL('@/assets/img/weather/rainshowers_day.svg', import.meta.url).href;
const rainshowers_night = new URL('@/assets/img/weather/rainshowers_night.svg', import.meta.url).href;
const rainshowers_polartwilight = new URL('@/assets/img/weather/rainshowers_polartwilight.svg', import.meta.url).href;
const sleet = new URL('@/assets/img/weather/sleet.svg', import.meta.url).href;
const sleetandthunder = new URL('@/assets/img/weather/sleetandthunder.svg', import.meta.url).href;
const sleetshowersandthunder = new URL('@/assets/img/weather/sleetshowersandthunder_day.svg', import.meta.url).href;
const sleetshowersandthunder_night = new URL('@/assets/img/weather/sleetshowersandthunder_night.svg', import.meta.url).href;
const sleetshowers = new URL('@/assets/img/weather/sleetshowers_day.svg', import.meta.url).href;
const sleetshowers_night = new URL('@/assets/img/weather/sleetshowers_night.svg', import.meta.url).href;
const snow = new URL('@/assets/img/weather/snow.svg', import.meta.url).href;
const snowandthunder = new URL('@/assets/img/weather/snowandthunder.svg', import.meta.url).href;
const snowshowersandthunder = new URL('@/assets/img/weather/snowshowersandthunder_day.svg', import.meta.url).href;
const snowshowersandthunder_night = new URL('@/assets/img/weather/snowshowersandthunder_night.svg', import.meta.url).href;
const snowshowers = new URL('@/assets/img/weather/snowshowers_day.svg', import.meta.url).href;
const snowshowers_night = new URL('@/assets/img/weather/snowshowers_night.svg', import.meta.url).href;

export const WeatherIconsUrls = {
    clearsky,
    clearsky_night,
    cloudy,
    fair,
    fair_night,
    fog,
    heavyrain,
    heavyrainandthunder,
    heavyrainshowersandthunder,
    heavyrainshowersandthunder_night,
    heavyrainshowers,
    heavyrainshowers_night,
    heavysleet,
    heavysleetandthunder,
    heavysleetshowersandthunder,
    heavysleetshowersandthunder_night,
    heavysleetshowers,
    heavysleetshowers_night,
    heavysnow,
    heavysnowandthunder,
    heavysnowshowersandthunder,
    heavysnowshowersandthunder_night,
    heavysnowshowers,
    heavysnowshowers_night,
    lightrain,
    lightrainandthunder,
    lightrainshowersandthunder,
    lightrainshowersandthunder_night,
    lightrainshowers,
    lightrainshowers_night,
    lightsleet,
    lightsleetandthunder,
    lightsleetshowers,
    lightsleetshowers_night,
    lightsnow,
    lightsnowandthunder,
    lightsnowshowers,
    lightsnowshowers_night,
    lightssleetshowersandthunder,
    lightssleetshowersandthunder_night,
    lightssnowshowersandthunder,
    lightssnowshowersandthunder_night,
    partlycloudy,
    partlycloudy_night,
    partlycloudy_polartwilight,
    rain,
    rainandthunder,
    rainshowersandthunder,
    rainshowersandthunder_night,
    rainshowers,
    rainshowers_night,
    rainshowers_polartwilight,
    sleet,
    sleetandthunder,
    sleetshowersandthunder,
    sleetshowersandthunder_night,
    sleetshowers,
    sleetshowers_night,
    snow,
    snowandthunder,
    snowshowersandthunder,
    snowshowersandthunder_night,
    snowshowers,
    snowshowers_night,
};
